import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComicView from '@/components/disposable/ComicView.vue';
import { ComicType } from '@/model/comic';

export default /*#__PURE__*/_defineComponent({
  __name: 'MangaChapterView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComicView, {
    type: _unref(ComicType).Manga
  }, null, 8, ["type"]))
}
}

})